module.exports = __webpack_public_path__ + "img/lun3.d57b4497.webp";